import { EventHint, Scope, Severity } from '@sentry/types';
import { Integrations } from "@sentry/tracing";

let Sentry = require('@sentry/react');

if (WEBPACK_ENV === 'production' && SENTRY_DSN) {
  const fixSentryRelease = (ref) => {
    try {
      return ref.split('/').pop();
    } catch (e) {
      return ref;
    }
  };

  Sentry.init({
    dsn: SENTRY_DSN,
    release: fixSentryRelease(GITHUB_REF) || GITHUB_SHA,
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 0.1,
  });
} else {
  /**
     * If Sentry is not enabled, override its methods to console methods so developers 
     * get instant feedback in the console without sending messages off to the server.
     */
  Sentry = {
    ...Sentry,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    captureException : (exception: any, hint?: EventHint, scope?: Scope): 
        string | undefined => {
      console.error(exception);
      
      return undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    captureMessage : (message: string, level?: Severity, hint?: EventHint, scope?: Scope):
        string | undefined => {
      console.warn(message);
      
      return undefined;
    },
  };
}

export default Sentry;
